module.exports = {"pyme":{"title":"Programa PYME","text":"<p>OPEN HEALTHCARE, S.L. ha sido beneficiaria de Fondos Europeos, cuyo objetivo es la mejora de la competitividad de las PYMES, y gracias al cual ha puesto en marcha un Plan de Acción con el objetivo de impulsar el uso seguro y fiable del ciberespacio y la competitividad de las pymes durante el año 2024. Para ello ha contado con el apoyo del Programa Pyme Cibersegura de la Cámara de Comercio de Sevilla. #EuropaSeSiente</p>"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/es/public/views/pyme.json
// module id = 347
// module chunks = 120